<template>
    <div v-if="invite.seats_available">
        <div class="bg-white text-dark text-center py-5">
            <h4 class="m-0 mb-5 mx-auto welcome">
                <b>Hey {{ invite.first_name }}</b>
                <span>,</span>
                {{ invite.coach ? invite.coach.account.full_name : "Someone" }} has invited you to train on
                Ladder, the world-class digital coaching platform.
            </h4>
            <v-flex class="invite-info" justify="center">
                <div v-if="parseFloat(invite.price)">
                    <v-flex align="center" justify="center">
                        <h4 class="number mb-0">$</h4>
                        <h1 class="mb-0 number">{{ invite.price_string }}</h1>
                    </v-flex>
                    <h4 class="mb-0">PER MONTH</h4>
                    <div
                        class="text-muted"
                        v-if="invite.trial_days"
                    >{{ invite.trial_days }} day trial</div>
                </div>
                <div v-else>
                    <h4 class="text-muted">Free Invitation</h4>
                </div>
            </v-flex>

            <v-button class="mt-5" size="xl" to="/checkout" variant="primary">Get started</v-button>
        </div>
        <ValuePropsCarousel class="mb-5 bg-white" />
    </div>
    <div class="p-5 text-center" v-else>
        <h4>This invitation is no longer available</h4>
    </div>
</template>

<script>
import ValuePropsCarousel from "@/components/ValuePropsCarousel";

export default {
    name: "InviteLandingView",
    components: {
        ValuePropsCarousel
    },
    props: {
        invite: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.welcome {
    width: 50%;
}

@media (max-width: #{map-get($grid-breakpoints, "sm")}) {
    .welcome {
        width: 90%;
    }
}
</style>